import React from "react";
import { useLanguage } from "@/lib/LanguageContext";
import { whatsappLink } from "@/lib/i18n";
import { MessageCircle } from "lucide-react";

const FloatingWhatsApp = () => {
  const { lang } = useLanguage();
  const label = lang === "id" ? "Chat WhatsApp" : "Chat WhatsApp";

  return (
    <a
      href={whatsappLink(
        lang === "id"
          ? "Halo RS Bhayangkara Tarakan, saya ingin bertanya."
          : "Hello RS Bhayangkara Tarakan, I have a question."
      )}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label={label}
      className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center shadow-xl shadow-green-500/30 pulse-ring transition-transform hover:scale-110"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
};

export default FloatingWhatsApp;
